/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadComment } from './LeadComment';
import {
    LeadCommentFromJSON,
    LeadCommentFromJSONTyped,
    LeadCommentToJSON,
    LeadCommentToJSONTyped,
} from './LeadComment';

/**
 * 
 * @export
 * @interface CreateLeadComment201Response
 */
export interface CreateLeadComment201Response {
    /**
     * 
     */
    data?: LeadComment;
}

/**
 * Check if a given object implements the CreateLeadComment201Response interface.
 */
export function instanceOfCreateLeadComment201Response(value: object): value is CreateLeadComment201Response {
    return true;
}

export function CreateLeadComment201ResponseFromJSON(json: any): CreateLeadComment201Response {
    return CreateLeadComment201ResponseFromJSONTyped(json, false);
}

export function CreateLeadComment201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadComment201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : LeadCommentFromJSON(json['data']),
    };
}

export function CreateLeadComment201ResponseToJSON(json: any): CreateLeadComment201Response {
    return CreateLeadComment201ResponseToJSONTyped(json, false);
}

export function CreateLeadComment201ResponseToJSONTyped(value?: CreateLeadComment201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeadCommentToJSON(value['data']),
    };
}

